import React, { useMemo, useCallback } from 'react';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { Form, Item, RequiredRule } from 'devextreme-react/form';
import useHandleTaskRates from '../../../Hooks/useHandleData/useHandleTaskRates';

const AddPopup = ({ popup, setPopup, formData, setFormData }) => {
    console.log(formData)

    const { handlePostTaskRate } = useHandleTaskRates();

    const addTaxRate = useCallback(async () => {
        let isDataGood = await handlePostTaskRate(formData);

        if (isDataGood) {
            setPopup(false);
            setFormData({
                task: formData.task,
                industry: 0,
                federal: 0,
                overhead: 0
            });
        }
    }, [formData, handlePostTaskRate, setFormData, setPopup]);

    const submitOptions = useMemo(() => {
        return {
            stylingMode: 'contained',
            text: "Send",
            onClick: () => { addTaxRate(); }
        }
    }, [addTaxRate]);

    const cancelOptions = useMemo(() => {
        return {
            stylingMode: "outlined",
            text: 'cancel',
            onClick: () => setPopup(false)  
        }
    }, [setPopup]);

    return (
        <Popup
            visible={popup}
            width="50%"
            height="auto"
            hideOnOutsideClick={true}
            onHiding={() => setPopup(false)}
            title="Add Task Rate"
        >
            <Form
                formData={formData}
                showValidationSummary={true}>
                <Item
                    dataField="year"
                    editorType="dxNumberBox">
                    <RequiredRule message="Year is required" />
                </Item>
                <Item
                    dataField="industry"
                    editorType="dxNumberBox">
                    <RequiredRule message="Rate is required" />
                </Item>
                <Item
                    dataField="federal"
                    editorType="dxNumberBox">
                    <RequiredRule message="Rate is required" />
                </Item>
                <Item
                    dataField="overhead"
                    editorType="dxNumberBox">
                    <RequiredRule message="Rate is required" />
                </Item>
            </Form>
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={cancelOptions}
            />
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="after"
                options={submitOptions}
            />
        </Popup>
    );
};

export default AddPopup;
